import React from 'react';
import { useSafeMode } from '../../contexts/SafeModeContext';
import { useAuth } from '../../contexts/AuthContext';
import { cn } from '../../lib/utils';
import UpgradeRequestBanner from '../billing/UpgradeRequestBanner';
import RequesterStatusBanner from '../billing/RequesterStatusBanner';
import FreeProductAvatarMenu from './FreeProductAvatarMenu';

const Header = ({ title, center, action, showUpgradeBanner = true }) => {
  const { getThemeColors } = useSafeMode();
  const { user, organization } = useAuth();
  const isFreeProduct = organization?.account_type === 'free_product';
  const colors = getThemeColors();
  
  // Determine if user is an owner (shows UpgradeRequestBanner) or PM/Collaborator (shows RequesterStatusBanner)
  // For now, we show both and let the components handle visibility based on user role
  const isOwner = user?.role === 'admin' || user?.teamRole === 'owner' || user?.teamRole === 'billing_admin';

  return (
    <>
      {/* Owner sees requests from team members */}
      {showUpgradeBanner && isOwner && <UpgradeRequestBanner />}
      
      {/* PM/Collaborators see their own request status */}
      {showUpgradeBanner && !isOwner && <RequesterStatusBanner />}
      
      <div className={cn(
        "px-8 py-4 sticky top-0 z-10 transition-all duration-300 border-b",
        colors.bgSecondary,
        colors.borderPrimary
      )}>
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-4 flex-1">
            {isFreeProduct && <FreeProductAvatarMenu />}
            <h2 className={cn("text-2xl font-semibold", colors.textPrimary)}>
              {title}
            </h2>
          </div>
          {center && (
            <div className="flex-1 flex items-center justify-center">
              {center}
            </div>
          )}
          {action && (
            <div className={cn("flex items-center gap-3", center ? "flex-1 justify-end" : "")}>
              {action}
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Header;
